module.exports = __webpack_public_path__ + "static/media/phone-app.28e7c76c.png";